module.exports = __webpack_public_path__ + "img/icon-s-air.92771d71.png";